<template>
	<div>
		<a class="hover-link" style="float:left;color:white;font-size: 14px;margin-right:40px;" @click="showModalTemp()">Collect Monthly Payment</a>
		<modal  :scrollable="true" name="debtors-monthly-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="1000">
			<collect-monthly-payment-form :building-id="buildingId" :period="period"></collect-monthly-payment-form>	
				


</modal>
	</div>
</template>
<script>
    export default {
        props : ['buildingId','period'],
        data: function () {
    return {
	}
},

        mounted() {
				//alert(this.buildingId);
        },

        methods: {
            beforeOpen (event) {

        },
                        showModal() {
        this.isModalVisible = true;

      },
      closeModal() {
        this.isModalVisible = false;
      },
					fetchStatement: function(){



					},
            showModalTemp: function(){
                    this.$modal.show('debtors-monthly-form');
                //alert("Id " + expenseId + " month " + month);
                //this.isModalVisible = true;

            },
                                show () {
    this.$modal.show('debtors-monthly-form');
  },
  hide () {
    this.$modal.hide('debtors-monthly-form');
  },

            /**
             * Prepare the component.
             */

            },

			computed : {
			total: function(){
                return this.expenseFees[0].reduce(function(total, fees){

                    return total + fees[0];
                },0);
        },
			}

	}                // Our Javascript logic


</script>
